import { cn } from '@/lib/utils'

interface BubleProps {
  className?: string
}

export const Buble = ({ className }: BubleProps) => {
  return (
    <div
      className={cn('absolute rounded-full bg-white/20 blur-[1000px]', className ? className : 'h-60 w-60 top-0 left-0')}
    />
  )
}
